<div
  [ngClass]="{
    'sidebar-full': !sidenavCollapsed,
    'sidebar-compact': sidenavCollapsed
  }"
>
  <div class="navigation-panel" fxLayout="column">
    <!-- TODO: Allow customization by organization -->
    <div class="app-brand">
      <img
        src="assets/images/MifosX_logo.png"
        alt="app-logo"
        class="app-logo"
      />
      <span class="app-logo-text text-muted">Mifos</span>
    </div>

    <div class="app-user">
      <div class="app-user-photo">
        <!-- TODO: Decision to be taken on providing this feature -->
        <img src="assets/images/user_placeholder.png" alt="app-user-photo" />
      </div>
      <span class="app-user-name mb-05">
        {{ username }}
      </span>
      <div class="app-user-controls">
        <button
          class="text-muted xs-button"
          mat-icon-button
          [matTooltip]="'COMMON.SETTINGS' | translate"
          [routerLink]="['/settings']"
        >
          <fa-icon icon="cog"></fa-icon>
        </button>
        <button
          class="text-muted xs-button"
          mat-icon-button
          [matTooltip]="'COMMON.SIGN_OUT' | translate"
          (click)="logout()"
        >
          <fa-icon icon="sign-out-alt"></fa-icon>
        </button>
      </div>
    </div>

    <div class="app-sidenav">
      <!-- TODO: Generate frequently accessed routes dynamically -->
      <div class="mt-1 mb-1 nav-item-sep">
        <mat-divider></mat-divider>
        <span class="text-muted icon-menu-title">{{
          "NAVIGATION.FREQUENTLY_ACCESSED" | translate
        }}</span>
      </div>
      <div class="icon-menu">
        <div class="icon-menu-item">
          <button
            mat-raised-button
            matTooltip="{{ 'COMMON.HOME' | translate }}"
            [routerLink]="['/home']"
          >
            <fa-icon icon="home" size="lg"></fa-icon>
          </button>
        </div>
      </div>

      <div class="nav-item-sep">
        <mat-divider></mat-divider>
        <span class="text-muted">{{ "SIDENAV.MAIN_ITEMS" | translate }}</span>
      </div>

      <mat-nav-list> </mat-nav-list>
    </div>
  </div>
</div>
